import { notifyError, notifySuccess } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

// update api
export const getLiveRoomAuctionList = (id) => async (dispatch) => {
  dispatch({ type: "SHOW_LIVE_AUCTION_LIST" });
  try {
    const { data } = await auction.get(
      `/live-auction/trader/read/live-auctions`
    );
    dispatch({ type: "FETCH_LIVE_AUCTION_LIST", payload: data });
  } catch (error) {
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
    dispatch({ type: "CANNOT_FETCH_LIVE_AUCTION_LIST" });
  }
};


//update api
export const getLivePaidEmdOffer = (auctionId) => async (dispatch) => {
  dispatch({ type: "LIVE_PAID_OFFER_LOADING" });
  try {
    const { data } = await auction.get(
      `/live-auction/trader/read/single-live-auction/${auctionId}`
    );
    dispatch({ type: "LIVE_PAID_OFFER_SUCCESS", payload: data });
  } catch (error) {
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
    dispatch({ type: "LIVE_PAID_OFFER_FAILED" });
  }
};

export const getLivePaidEmdOfferForProduct = (auctionId) => async (dispatch) => {
  dispatch({ type: "LIVE_PAID_OFFER_LOADING" });
  try {
    const { data } = await auction.get(
      `/live-auction/trader/read/revers-single-live-auction/${auctionId}`
    );
    dispatch({ type: "LIVE_PAID_OFFER_SUCCESS", payload: data });
  } catch (error) {
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
    dispatch({ type: "LIVE_PAID_OFFER_FAILED" });
  }
};

export const getLivePaidEmdOfferForService = (auctionId) => async (dispatch) => {
  dispatch({ type: "LIVE_PAID_OFFER_LOADING" });
  try {
    const { data } = await auction.get(
      `/live-auction/trader/read/revers-single-live-auction/${auctionId}`
    );
    dispatch({ type: "LIVE_PAID_OFFER_SUCCESS", payload: data });
  } catch (error) {
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
    dispatch({ type: "LIVE_PAID_OFFER_FAILED" });
  }
};

// export const getBidHistoryDetails = (actionId) => async (dispatch) => {
//   dispatch({ type: "LIVE_AUCTION_HISTORY_LOADING" });
//   try {
//     const { data } = await auction.get(
//       `/auction/read/live-data?auctionId=${actionId}`
//     );
//     dispatch({ type: "LIVE_AUCTION_HISTORY_SUCCESS", payload: data });
//   } catch (error) {
//     notifyError(
//       error.response ? error.response?.data : error.message,
//       error.response?.status
//     );
//     dispatch({ type: "LIVE_AUCTION_HISTORY_FAILED" });
//   }
// };


// update api
export const postLiveRoomData =
  (amount, manualBid = false, auctionId, offerId) =>
    async (dispatch) => {
      dispatch({
        type: "LIVE_ROOM_DATA_FETCHING",
        loadingId: offerId,
      });
      try {
        const { data } = await auction.post(
          `/live-auction/trader/add-bid/${auctionId}/${offerId}`,
          { bidAmount: amount }
        );
        if (manualBid) {
          notifySuccess("Bid placed successfully.");
        }
        dispatch({ type: "LIVE_ROOM_DATA_SUCCESS", payload: data });
      } catch (error) {
        if (
          error?.response?.data?.error &&
          error.response.data.error?.includes(
            "Bid amount must be higher than the current highest bid."
          )
        ) {
          // dispatch(getLiveAuctionHistoryData(auctionId, updateData?.userId));
          notifyError("Sorry, your bid was not placed. Please try again.");
        } else {
          notifyError(error.response ? error.response?.data : error.message,);
        }
        dispatch({ type: "CANNOT_LIVE_ROOM_DATA" });
      }
    };

export const postLiveRoomDataForProduct =
  (amount, manualBid = false, auctionId, offerId) =>
    async (dispatch) => {
      dispatch({
        type: "LIVE_ROOM_DATA_FETCHING",
        loadingId: offerId,
      });
      try {
        const { data } = await auction.post(
          `/live-auction/trader/revers-product-offer/add-bid/${auctionId}/${offerId}`,
          { bidAmount: amount }
        );
        if (manualBid) {
          notifySuccess("Bid placed successfully.");
        }
        dispatch({ type: "LIVE_ROOM_DATA_SUCCESS", payload: data });
      } catch (error) {
        if (
          error?.response?.data?.error &&
          error.response.data.error?.includes(
            "Bid amount must be higher than the current highest bid."
          )
        ) {
          // dispatch(getLiveAuctionHistoryData(auctionId, updateData?.userId));
          notifyError("Sorry, your bid was not placed. Please try again.");
        } else {
          notifyError(error.response ? error.response?.data : error.message,);
        }
        dispatch({ type: "CANNOT_LIVE_ROOM_DATA" });
      }
    };

    export const postLiveRoomDataForService =
  (amount, manualBid = false, auctionId, offerId) =>
    async (dispatch) => {
      dispatch({
        type: "LIVE_ROOM_DATA_FETCHING",
        loadingId: offerId,
      });
      try {
        const { data } = await auction.post(
          `/live-auction/trader/revers-service-offer/add-bid/${auctionId}/${offerId}`,
          { bidAmount: amount }
        );
        if (manualBid) {
          notifySuccess("Bid placed successfully.");
        }
        dispatch({ type: "LIVE_ROOM_DATA_SUCCESS", payload: data });
      } catch (error) {
        if (
          error?.response?.data?.error &&
          error.response.data.error?.includes(
            "Bid amount must be higher than the current highest bid."
          )
        ) {
          // dispatch(getLiveAuctionHistoryData(auctionId, updateData?.userId));
          notifyError("Sorry, your bid was not placed. Please try again.");
        } else {
          notifyError(error.response ? error.response?.data : error.message,);
        }
        dispatch({ type: "CANNOT_LIVE_ROOM_DATA" });
      }
    };

export const postLiveBiddetails = (auctionId) => async (dispatch) => {
  dispatch({ type: "LIVE_BID_HISTORY_LOADING" });
  try {
    const { data } = await auction.post("/auction/read/auction-data", {
      auctionId: auctionId,
    });
    dispatch({ type: "LIVE_BID_HISTORY_SUCCESS", payload: data });
  } catch (error) {
    notifyError(error?.response?.data?.error);
    dispatch({ type: "LIVE_BID_HISTORY_FALIED" });
  }
};

// export const getLiveAuctionHistoryData = (auctionId) => async (dispatch) => {
//   dispatch({ type: "LIVE_ROOM_HISTORY_FETCHING" });
//   try {
//     const { data } = await auction.get(
//       `/auction/read/live-lot-state?auctionId=${auctionId}`
//     );
//     dispatch({ type: "LIVE_ROOM_HISTORY_SUCCESS", payload: data });
//   } catch (error) {
//     notifyError(error?.response?.data?.error);
//     dispatch({ type: "CANNOT_LIVE_ROOM_HISTORY" });
//   }
// };

export const cancelAutoBid = (cancelData) => async (dispatch) => {
  dispatch({ type: "CANCEL_AUTO_BID" });
  try {
    const { data } = await auction.post(
      `/auction/read/cancel-auto-bid`,
      cancelData
    );
    const response = { ...data, offerId: cancelData?.offerId };
    dispatch({ type: "CANCEL_AUTO_BID_SUCCESS", payload: response });
  } catch (error) {
    notifyError(error?.response?.data?.error);
    dispatch({ type: "CANNOT_CANCEL_AUTO_BID" });
  }
};

//update api
export const getAllSellerLiveAuction = () => async (dispatch) => {
  dispatch({ type: "SHOW_LIVE_AUCTION_SELLER" });
  try {
    const { data } = await auction.get(
      `/live-auction/industry/read/live-auctions`
    );
    dispatch({ type: "SUCCESS_LIVE_AUCTION_SELLER", payload: data });
  } catch (error) {
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
    dispatch({ type: "CANNOT_FETCH_LIVE_AUCTION_SELLER" });
  }
};

//update api
export const readSingleLiveIndustryAuction = (auctionId) => async (dispatch) => {
  dispatch({ type: "READ_SINGLE_LIVE_SELLER_LOADING" });
  try {
    const { data } = await auction.get(
      `/live-auction/industry/read/single-auction/${auctionId}`
    );
    dispatch({ type: "READ_SINGLE_LIVE_SELLER_SUCCESS", payload: data });
  } catch (error) {
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
    dispatch({ type: "READ_SINGLE_LIVE_SELLER_FAILED" });
  }
};

// export const getLiveAuctionSellerHistory = (auctionId) => async (dispatch) => {
//   dispatch({ type: "SHOW_LIVE_AUCTION_SELLERS" });
//   try {
//     const { data } = await auction.get(
//       `/auction/read/live-seller-history?auctionId=${auctionId}`
//     );
//     dispatch({ type: "LIVE_ROOM_SELLER_HISTORY_SUCCESS", payload: data });
//   } catch (error) {
//     notifyError(error?.response?.data?.error);
//     dispatch({ type: "CANNOT_FETCH_LIVE_AUCTION_SELLERS" });
//   }
// };

export const payEmdInliveroom =
  (auctionId, userId, profileId, offer, setIsModalOpen) => async (dispatch) => {
    dispatch({ type: "SHOW_LIVE_PAY_EMD" });
    try {
      const { data } = await auction.put(
        `/auction/update/pay-deposit-live-auction/${auctionId}`,
        offer
      );
      setIsModalOpen(false);
      notifySuccess("EMD paid successfully.");
      dispatch(getLivePaidEmdOffer(auctionId));
      dispatch({ type: "SUCCESS_LIVE_PAY_EMD", payload: data });
    } catch (error) {
      notifyError(
        error.response ? error.response?.data : error.message,
        error.response?.status
      );
      setIsModalOpen(false);
      dispatch({ type: "FAILED_LIVE_PAY_EMD" });
    }
  };
